module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/dashboard'
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/timeline'
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" Timeline")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/components'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _vm._v(" Mystique")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/mystique/realms',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-briefcase"
  }), _vm._v(" Realms")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/mystique/groups',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-people"
  }), _vm._v(" Grupo")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/mystique/users',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" Usuários")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/mystique/audit',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" Auditoria")])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/components'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-object-group"
  }), _vm._v(" Cerebro")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cerebro/entities',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-object-ungroup"
  }), _vm._v(" Entidades")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cerebro/links',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa fa-link"
  }), _vm._v(" Links")])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/components'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "icon-rocket"
  }), _vm._v(" Rocket")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/rocket/configurations',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-puzzle"
  }), _vm._v(" Configurações")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/rocket/webhooks',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Webhooks")])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/components'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" Beast")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/beast/decisions',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" Decisions")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/beast/workflows',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" Workflows")])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/components'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" Shaw")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/shaw/events',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" Events")])], 1)])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e32371d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e32371d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1565
// module chunks = 1